const datePipe = (date) => {
	const monthList = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря']
	const newDate = new Date(date)
	return newDate.getDate() + ' ' + monthList[newDate.getMonth()] 
}

export default datePipe;